//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/SmartObject.js";
import "../no/ugmath.js";
import "../no/BasePart.js";
let d=[[],[[["start_point","end_point"],"CreateLine",{R_:{line:"Line"}},2,0],[["start_point","end_point"],"CreateLine1",{R_:{line:"Line"}},2,0],[["start_point","end_point"],"CreateInfiniteLine",{R_:{infiniteline:"InfiniteLine"}},2,0],[["line"],"CreatePairedInfiniteLine",{R_:{infiniteline:"InfiniteLine"}},1,0],[["start_point","point_on","end_point","alternate_solution","start_and_end_got_flipped"],"CreateArc",{R_:{arc:"Arc"}},4,0],[["center","matrix","radius","start_angle","end_angle"],"CreateArc1",{R_:{arc:"Arc"}},5,0],[["center","x_direction","y_direction","radius","start_angle","end_angle"],"CreateArc2",{R_:{arc:"Arc"}},6,0],[["center","major_radius","minor_radius","start_angle","end_angle","rotation_angle","matrix"],"CreateEllipse",{R_:{ellipse:"Ellipse"}},7,0],[["center","x_direction","y_direction","major_radius","minor_radius","start_angle","end_angle"],"CreateEllipse1",{R_:{ellipse:"Ellipse"}},7,0],[["center","focal_length","minimum_d_y","maximum_d_y","rotation_angle","matrix"],"CreateParabola",{R_:{parabola:"Parabola"}},6,0],[["center","x_direction","y_direction","focal_length","minimum_d_y","maximum_d_y"],"CreateParabola1",{R_:{parabola:"Parabola"}},6,0],[["center","semi_transverse_length","semi_conjugate_length","minimum_d_y","maximum_d_y","rotation_angle","matrix"],"CreateHyperbola",{R_:{hyperbola:"Hyperbola"}},7,0],[["center","x_direction","y_direction","semi_transverse_length","semi_conjugate_length","minimum_d_y","maximum_d_y"],"CreateHyperbola1",{R_:{hyperbola:"Hyperbola"}},7,0],[["update_option","blendFace","tolerance"],"CreateVirtualBlendCurve",{R_:{virtualBlendCurve:"Curve"}},3,0],[["update_option","blendFace","tolerance"],"CreateVirtualCenterlineCurve",{R_:{virtualCenterlineCurve:"Curve"}},3,0],[["section","update_option","tolerance"],"CreateSmartCompositeCurve",{R_:{smartCompositeCurve:"Curve"}},3,0],[["curve","update_option"],"CreateSmartCompositeCurve1",{R_:{smartCompositeCurve:"Curve"}},2,0],[["curve_to_extract","type","subtype","xform","tolerance","update_option"],"CreateExtractedCurve",{R_:{extracted_curve:"ICurve"}},6,0]],[]];
SPLM.CurveCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CurveCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;